import { render } from "./PieCharts.vue?vue&type=template&id=195d8e60&scoped=true"
import script from "./PieCharts.vue?vue&type=script&lang=js"
export * from "./PieCharts.vue?vue&type=script&lang=js"

import "./PieCharts.vue?vue&type=style&index=0&id=195d8e60&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.28_vue@3.5.28_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195d8e60"]])

export default __exports__